<template>
  <div class="root">
    <!-- <img src="@/assets/mock_point_rule.jpg" width="100%" alt /> -->
    <div ref="head" class="container head">
      <div class="row justify-content-between cover py-12">

        <!-- <div class="col-3 float-left text-left py-2"> -->
        <!-- <img class="p-1" alt="logo" width="82" src="@/assets/bevfam_logo.jpg" /> -->
        <!-- </div> -->
        <!-- <div class="col px-0 title text-center">
          ข้อมูลรายการสินค้า
        </div> -->
      </div>
      <div v-if="dataStage == 'ok'" class="row category-btn-row">
        <div class="col p-0 d-flex">
          <button :class="['category-btn', selectedAlcohol === 0 ? 'active' : '']"
            @click="selectCategory(0)">เครื่องดื่มไม่มีแอลกอฮอล์</button>
          <button :class="['category-btn', selectedAlcohol === 1 ? 'active' : '']"
            @click="selectCategory(1)">เครื่องดื่มมีแอลกอฮอล์</button>
        </div>
      </div>
      <div v-if="dataStage == 'ok'" class="row">
        <div class="col p-0">
          <nav class="nav nav-tabs">
            <a :id="'brand_' + it.id" v-on:click="tabClick(it.id)" v-for="(it, index) in filteredData" :key="index"
              :class="'nav-item nav-link'" :data-tag="'brand_' + it.id">
              <img width="100%" :src="it.image" alt />
            </a>
          </nav>
        </div>
      </div>
    </div>
    <div v-if="dataStage == 'nodata'" class="text-center mt-3">ไม่พบข้อมูล</div>

    <div ref="dataItems" class="dataItems">
      <div v-if="dataItems" class="point-rule-banner">
        <img :src="dataItems.banner_url" width="100%" alt="" />
      </div>
      <div class="rows" v-for="it in dataItems.products" :key="it.code">

        <div class="card">
          <!-- <div class="card-header">
            {{ dataItems.NameEN }} | {{ dataItems.nameTH }}
          </div> -->
          <img v-lazy="it.image" width="100%" />
          <div class="card-body">
            <b>{{ it.description }}</b>
            <br />
            <!-- <div class="point_seg">
              <b>{{ it.point }} คะแนน</b>
            </div> -->
          </div>
        </div>
      </div>
      <div class="text-center" v-if="itemsStage == 'nodata'">
        ไม่พบข้อมูลรายการนี้
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PointRule",
  data() {
    return {
      dataStage: "loading",
      data: [],
      file_name: "",
      dataItems: [],
      itemsStage: "ok",
      selectedAlcohol: 0,
    };
  },
  computed: {
    filteredData() {
      return this.data.filter((it) => Number(it.is_alcohol) === this.selectedAlcohol);
    },
  },
  methods: {
    async fetchData() {
      // get shop info
      return await fetch(`${process.env.VUE_APP_API_URL}/point_rules`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.$JWT}`,
        },
      });
    },
    async getData() {
      try {
        const res = await this.fetchData();
        console.log("fetchData status:", res.status);
        let body = [];
        try {
          body = await res.json();
        } catch {
          body = [];
        }
        this.data = body;
        if (this.data.length == 0) {
          this.dataStage = "nodata";
        } else {
          this.dataStage = "ok";
          this.$nextTick(() => {
            const first = this.filteredData[0] || this.data[0];
            if (first) this.tabClick(first.id);
          });
        }

        console.log("fetchData body:", body);
      } catch (error) {
        this.dataStage = "nodata";
        console.log(error);
      }
    },
    selectCategory(val) {
      this.selectedAlcohol = val;
      this.dataItems = [];
      this.itemsStage = "ok";
      this.$nextTick(() => {
        if (this.filteredData.length > 0) {
          this.tabClick(this.filteredData[0].id);
        }
        this.adjustDataItemsMargin();
      });
    },
    adjustDataItemsMargin() {
      this.$nextTick(() => {
        if (this.$refs.head && this.$refs.dataItems) {
          const headHeight = this.$refs.head.offsetHeight;
          this.$refs.dataItems.style.marginTop = headHeight + 'px';
        }
      });
    },
    tabClick(id) {
      window.scrollTo(0, 0);
      const nav = document.getElementsByClassName("nav-item"); // document.getElementById("brand_" + key).classList.add("active");
      for (let i = 0; i < nav.length; i++) {
        nav[i].classList.remove("active");
      }

      document.getElementById("brand_" + id).classList.add("active");
      this.dataItems = this.data.filter((it) => {
        return it.id == id;
      });
      this.dataItems = this.dataItems[0];
      if (this.dataItems.products.length == 0) {
        this.itemsStage = "nodata";
      } else {
        this.itemsStage = "ok";
      }
    },
  },
  updated() {
    this.adjustDataItemsMargin();
  },
  mounted() {
    this.getData();
    this.adjustDataItemsMargin();

    window.loading(false);
  },
};
</script>

<style>
body {
  background: "#ffffff";
}
</style>

<style lang="scss" scoped>
.head {
  position: fixed;
  top: 0;
  z-index: 1;
  max-width: 450px;
}

.cover {
  background-image: url("~@/assets/bevfam_full_bg.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  aspect-ratio: 10 / 2;
  /* ความสูงตามสัดส่วนภาพ (ปรับ ratio ตามขนาดภาพจริง) */
}

.title {
  color: rgb(255, 255, 255);
  font-size: calc(120%);
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.category-btn-row {
  background: #ffffff;
  padding: 8px 12px;
}

.category-btn-row .col {
  background: #e0e0e0;
  border-radius: 10px;
  padding: 4px !important;
}

.category-btn {
  flex: 1;
  padding: 8px 12px;
  font-size: 0.85em;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: #888;
  cursor: pointer;
  transition: all 0.2s;

  &.active {
    background: #2e7d50;
    color: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
}

nav {
  background: #ffffff;
  flex-wrap: inherit;
  overflow-x: auto;
}

.nav-item {
  padding: 5px;
  flex: 0 0 auto;

  img {
    height: 40px;
    width: 40px;
  }
}

.image_brand {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 40px;
}

.dataItems {
  margin: 0 0 50px 0;
}

.point-rule-banner {
  width: 100%;
  line-height: 0;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.dataItems .rows {
  margin: 0px 0;
}

.card-header {
  padding: 0.2rem 1.25rem;
  margin-bottom: 0;
  color: #ffffff;
  background-color: #0096dc;
  border: none;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.125); */
  border-radius: 0px;

}

.card {
  border: none;
  // box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.05);
  border-radius: 0px;
}

.point_seg {
  font-size: 1.2em;
}

/* .card {
  padding: 15px 10px;
  margin: 15px 0;
  background: #ffffff;
  border-radius: 15px;
} */

/* .card-head {
  background: #0096dc;
} */
</style>